export const createLocalAssetPath = (filePath: string) => {
  return isDESKTOP ? `ma://${filePath}` : `${filePath}`;
};
